import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_BASE_URL;

// 🔹 Async Thunk for Admin Login
export const loginAdmin = createAsyncThunk(
  "admin/login",
  async (credentials, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${Baseurl}/api/v1/admin/login`, credentials, { credentials: "include" });
      sessionStorage.setItem("token", data.token);

      
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

// 🔹 Async Thunk for Admin Logout
export const logoutAdmin = createAsyncThunk("admin/logout", async () => {
  sessionStorage.removeItem("token");
  localStorage.removeItem("admin");
  return null;
});

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    admin: null,
    token: sessionStorage.getItem("token") || null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginAdmin.fulfilled, (state, action) => {
        state.loading = false;
        localStorage.setItem("admin", JSON.stringify(action.payload.admin));
        state.admin = action.payload.admin;
        state.token = action.payload.token; // ✅ Store token in state
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutAdmin.fulfilled, (state) => {
        state.admin = null;
        state.token = null;
      });
  },
});

export default adminSlice.reducer;
